import axios from 'axios'
import {BUSCAR_AGENCIAS} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';
import {montarURLFiltro} from '../../util/filtros';

export default function buscarAgencias(idEmpresa, pagina, registrosPorPagina, filtros) {

    const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
    const url = `${URL}/agencia/empresa/${idEmpresa}${urlFiltros}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_AGENCIAS,
            payload: response

        })
    );
}
